// src/utils/geocodeAddress.js

const getCoordinatesFromAddress = async (address) => {
  try {
    if (!address || address.trim() === "") {
      console.warn("⏩ Skipping geocode: Empty address provided.");
      return null;
    }

    const encoded = encodeURIComponent(address);
    const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encoded}`;
    const response = await fetch(url);
    const data = await response.json();

    if (Array.isArray(data) && data.length > 0) {
      const { lat, lon } = data[0];
      return {
        latitude: parseFloat(lat),
        longitude: parseFloat(lon),
      };
    } else {
      console.warn("⚠️ No results for address:", address);
      return null;
    }
  } catch (error) {
    console.error("❌ Error geocoding address:", address, error);
    return null;
  }
};

export default getCoordinatesFromAddress;
